export type Shift = 1 | 2;

export const SHIFT_LABEL: Record<Shift, string> = {
  1: "07:00–15:00",
  2: "15:00–23:00",
};
